export default __webpack_public_path__ + "static/media/card-profile-sweepstakes.5832a863.jpg";